import React from "react";
import Marquee from "react-fast-marquee";

export const TopHeader = () => {
  return (
    <div className="d-grid">
      <div className="top-header-container">
        <div className="custom-header-container py-2 px-sm-0 px-lg-3">
          <Marquee>
            {/* " We are Surat’s Leading clothing Manufacturer, Shipping Globally for Over 44+ Years."&nbsp; */}
            Since 1977, a leading Surat-based manufacturer of premium sarees, women's wear, men's wear, and kids' wear, exporting to over 80 countries worldwide.
          </Marquee>
        </div>
      </div>
    </div>
  );
};
